module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_vm._v("高校管理")]), _vm._v(" "), _c('div', {
    staticClass: "search-wrapper"
  }, [_c('el-select', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "placeholder": "请选择高校",
      "size": "small",
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.onSchoolChange
    },
    model: {
      value: (_vm.queryForm.rootUnid),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "rootUnid", $$v)
      },
      expression: "queryForm.rootUnid"
    }
  }, _vm._l((_vm.schoolList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.rootUnid
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "signed-filter"
  }, [_c('span', {
    staticClass: "signed-filter__label"
  }, [_vm._v("学校是否签约")]), _vm._v(" "), _c('el-radio-group', {
    staticClass: "signed-filter__radios",
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.handleSearch
    },
    model: {
      value: (_vm.signedFilter),
      callback: function($$v) {
        _vm.signedFilter = $$v
      },
      expression: "signedFilter"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": ""
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("正式签约")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("意向签约")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "0"
    }
  }, [_vm._v("未签约")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "type": "index",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "学校名称",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "学校类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(" " + _vm._s(scope.row.schoolType == 4 ? '高中' : '大学'))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "学校是否签约"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(_vm.signedText(row)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "校区数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(row.campusNum))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "是否启用一体机"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n               " + _vm._s((row.config && row.config.enableOnePC) ? "是" : "否") + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "场馆运动时长监控"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v(_vm._s(_vm.handleSportTimeConfig(row)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "硬件防作弊"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n               " + _vm._s((row.config && row.config.hardwareCollection) ? "开启" : "关闭") + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "教师管理人脸"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_vm._v("\n               " + _vm._s((row.config && row.config.enableTeacherInputFace) ? "开启" : "关闭") + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.editschool(row)
            }
          }
        }, [_vm._v("编辑")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-wrapper"
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, prev, pager, next",
      "current-page": _vm.queryForm.pageNum,
      "page-size": _vm.queryForm.pageSize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handlePageChange
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b9057642!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UniversityManage/UniversityManage/CollegeManage/CollegeManage.vue
// module id = 1117
// module chunks = 0